export default function RefreshIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.8334 14.9999H8.33335C4.65146 14.9999 1.66669 12.0152 1.66669 8.33325V5.83325"
        stroke="#1976D2"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11.6663L10.8331 14.9993L7.5 18.3324"
        stroke="#1976D2"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16669 5L11.6667 5C15.3486 5 18.3334 7.98477 18.3334 11.6667V14.1667"
        stroke="#1976D2"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 8.33243L9.16693 4.99934L12.5 1.66626"
        stroke="#1976D2"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
